const KEY_COMMENTS = 'COMMENTS'
const GET_COMMENTS = process.env.REACT_APP_COMMENTS
const CREATE_COMMENTS = process.env.REACT_APP_COMMENTS
const DELETE_COMMENTS = process.env.REACT_APP_COMMENTS
const UPDATE_COMMENTS = process.env.REACT_APP_COMMENTS

export { KEY_COMMENTS, GET_COMMENTS, CREATE_COMMENTS, DELETE_COMMENTS, UPDATE_COMMENTS }
